import * as Yup from "yup";
import { testPhoneDDD, testPhoneNumber } from "../../../../../../utils/phone";

export const validationSchema = Yup.object({
  cellphone: Yup.string()
    .test("cellphone", "Número de telefone Inválido.", (value) =>
      testPhoneNumber(value)
    )
    .test("cellphone", "Número de DDD Inválido.", (value) =>
      testPhoneDDD(value)
    ),
});
